import React from 'react'
import { getAllFocusableElements } from 'common/helpers'

import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'
import Message from 'components/text/Message/Message'

import messages from './messages'


const focusOnMainContent = (contentId) => (event) => {
  event.preventDefault()

  const mainContentEl           = document.getElementById(contentId)
  const mainContentFocusableEls = getAllFocusableElements(mainContentEl)
  const firstFocusableEl        = mainContentFocusableEls[0]

  if (firstFocusableEl) {
    firstFocusableEl.focus()
  }
}

const SkipContent = ({ skipContentTitle, contentId }) => {
  const text = skipContentTitle === 'queue' ? messages.skipQueueTitle : messages.title

  return (
    <VisuallyHidden>
      <Message
        tag="a"
        href={`#${contentId}`}
        text={text}
        onClick={focusOnMainContent(contentId)}
      />
    </VisuallyHidden>
  )
}


export default SkipContent
